/* eslint-disable react/react-in-jsx-scope */
import React from "react";
import {
  Box,
  Grid,
  Typography,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import NJSLogo from "src/assets/images/tfg_mainlogo.svg";

const reasonList = [
  { label: "Distance - Too Far" },
  { label: "Not interested in Taking on More Work at this time" },
  { label: "Type of Service - Do not Perform" },
  { label: "Other" },
];

function ThankYou() {
  const parentUrl = process.env.REACT_APP_API_URL;
  const id = window.location.search.split("=")[1];
  const pageRout = window.location.pathname;
  const [selecteReason, setSelecteReason] = React.useState<string>("");
  const [declineReason, setDeclineReason] = React.useState<boolean>(false);
  const [loader, setLoader] = React.useState<boolean>(false);
  const [onLoadFristTime, setOnLoadFristTime] = React.useState<boolean>(true);
  if (pageRout === "/thank-you" && onLoadFristTime) {
    const parms = {
      rounddetailId: parseInt(id),
      response: "Accepted",
    };
    const url = "accept-decline-announcement-round-detail";
    thankYouResponce(parms, url);
    setOnLoadFristTime(false);
  }
  if (pageRout === "/unsubscribe" && onLoadFristTime) {
    const parms = {
      rounddetailId: parseInt(id),
    };
    const url = "unsub-announcement-orders";
    thankYouResponce(parms, url);
    setOnLoadFristTime(false);
  }
  async function thankYouResponce(parms: any, url: string) {
    setLoader(true);
    try {
      const res = await fetch(`${parentUrl}${url}`, {
        method: "POST",
        body: JSON.stringify(parms),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });
      if (res.status === 200) {
        setDeclineReason(true);
      } else {
        console.log(res);
      }
    } catch (error: any) {
      console.log(error);
    }
    setLoader(false);
  }
  return (
    <>
      <Backdrop style={{ zIndex: 2, color: "#fff" }} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box pt={5} textAlign="center">
        <Grid container direction="row">
          <Grid item xs={12} md={12}>
            {pageRout === "/decline" && !declineReason ? (
              <Grid item xs={12}></Grid>
            ) : (
              <Grid item xs={12}>
                <CheckOutlinedIcon
                  style={{
                    height: "3.5em",
                    width: "3.5em",
                    color: "white",
                    background: "green",
                    borderRadius: "50%",
                  }}
                />
              </Grid>
            )}
            <Box mt={5}>
              {pageRout === "/thank-you" && <Typography>Thank you for accepting.</Typography>}
              {pageRout === "/unsubscribe" && (
                <Typography>
                  Thank you for unsubscribe you will never receive email again.
                </Typography>
              )}
              {pageRout === "/decline" && (
                <Box>
                  {!declineReason && (
                    <>
                      <Typography component={"h6"} variant={"body1"}>
                        Select Reason for decline.
                      </Typography>
                      <Autocomplete
                        id="size-small-standard"
                        size="small"
                        options={reasonList || []}
                        onInputChange={(_e, v) => {
                          setSelecteReason(v);
                        }}
                        getOptionLabel={(option) => option.label || ""}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            id="outlined-basic"
                            label={"Reasons"}
                            name="Vendor Name"
                            variant="outlined"
                            size="small"
                            InputLabelProps={{
                              shrink: true,
                            }}
                            style={{ width: "50%", marginBottom: 20 }}
                          />
                        )}
                      />
                      <Box component="span" mr={1} mb={1}>
                        <Button
                          variant="contained"
                          //color="primary"
                          size="small"
                          style={{
                            background: selecteReason && "green",
                            color: selecteReason && "white",
                          }}
                          disabled={selecteReason === ""}
                          onClick={(event: { stopPropagation: () => void }) => {
                            event.stopPropagation();
                            const parms = {
                              rounddetailId: parseInt(id),
                              reponse: "Declined",
                              declinedReason: selecteReason,
                            };
                            const url = "accept-decline-announcement-round-detail";
                            thankYouResponce(parms, url);
                          }}
                        >
                          Save
                        </Button>
                      </Box>
                    </>
                  )}
                  {declineReason && <Typography>Thank you for decline.</Typography>}
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>
        <Box style={{ position: "absolute", bottom: 20, minWidth: "-webkit-fill-available" }}>
          <Box my={2} mt={10} textAlign="center">
            <a href="/" className="headerLogoLink">
              <img src={NJSLogo} alt="logo" width="240" />
            </a>
          </Box>
          <Typography>Copyright© {new Date().getFullYear()} | All Rights Reserved</Typography>
        </Box>
      </Box>
    </>
  );
}

export default ThankYou;
